import type { TOC } from '@ember/component/template-only';

export interface BvCardSubsectionSignature {
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvCardSubsectionComponent: TOC<BvCardSubsectionSignature> = <template>
  <div class='bv-card__subsection' ...attributes>
    {{yield}}
  </div>
</template>;

export default BvCardSubsectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvCard::Subsection': typeof BvCardSubsectionComponent;
    'bv-card/subsection': typeof BvCardSubsectionComponent;
  }
}
